import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogOpenReport, DialogShow, DialogShow_2 } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";

//PAGE
import P231List from "./P231List";
import P231Search from "./P231Search";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P231GetColumnList, P231GetDataHead, P231GetDataList, P231UpdateDetailData, P231UpdateData } from "../../../service/200/P231Service";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";
import { pdfRPT232 } from "../../../Report/232/RPT232";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { NullInt, NullSelect, NullString, ZeroToNull } from "../../../utilities/NullUtil";
import { formatDateAPI } from "../../../utilities/DateUtil";
import { wordRPT232 } from "../../../Report/232/RPT232Word";
import { onP232GetDataPrint } from "../../../Report/232/RPT232CallService";

export default function P231() {
    const history = useHistory();
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });
    const [errData, setErrData] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");

    const [dataHead, setDataHead] = useState({
        letterDate: "",
        deliverBeginDate: "",
        deliverEndDate: "",
        meetingDate: "",
        letterNo: "",
    });
    const [dataRPT, setDataRPT] = useState([]);

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        routeNo: 0,
        deliverNo: 0,
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state ? history.location.state : ""),
    });

    const [dataTable, setDataTable] = useState([]);
    const [dataTableCol, setDataTableCol] = useState([]);
    const [keyList, setKeyList] = useState(["", ""]);

    useEffect(() => {
        if (dataUserSession()) {
            if (!history.location.state) {
                history.push("/208");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        setTimeout(async () => {
            await Promise.all([onP231GetDataList(), onP231GetColumnList()]);
            await onP231GetDataHead();

            onP232GetDataPrint(setLoading, searchData, setDataRPT, toast);
        }, 10);
        setLoading(false);
    }, [searchData]);

    const onP231GetDataHead = async () => {
        // setLoading(true);
        await P231GetDataHead(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    if (res[0]) {
                        setDataHead({
                            ...res[0],
                            letterDate: new Date(res[0].letterDate),
                            deliverBeginDate: new Date(res[0].deliverBeginDate),
                            deliverEndDate: new Date(res[0].deliverEndDate),
                            meetingDate: new Date(res[0].meetingDate),
                        });
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP231GetColumnList = async () => {
        // setLoading(true);
        await P231GetColumnList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('Hd ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let keyList = ["", ""];
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            contractAmount: ZeroToNull(element.contractAmount),
                            contractUnit: ZeroToNull(element.contractUnit),
                            itemUnitPrice: ZeroToNull(element.itemUnitPrice),
                            index: index,
                        });

                        keyList.push(element.updateKey);
                        index++;
                    });

                    setKeyList(keyList);
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP231GetDataList = async () => {
        // setLoading(true);
        await P231GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log('col ',res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTableCol(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object) => {
        let list = ["letterNo", "letterDate", "deliverBeginDate", "deliverEndDate", "meetingDate"];
        let check = true,
            submit = false;
        list.forEach((item) => {
            if (object[`${item}`] === "") {
                submit = true;
                check = false;
            }
        });

        setSubmitted(submit);
        return check;
    };

    const submitForm = async (detailData) => {
        if (validation(dataHead)) {
            setLoading(true);
            let deliverNo = await onP231UpdateDataHader(dataHead);

            if (detailData && detailData.length > 0 && deliverNo > 0) {
                // setLoading(true);
                await Promise.all(
                    detailData.map(async (item) => {
                        onP231UpdateDetailData({ ...item, deliverNo });
                    })
                );
            }

            setSearchData({
                ...searchData,
                deliverNo,
            });
            setLoading(false);
        } else {
            window.scroll({ top: 0, behavior: "smooth" });
        }
    };

    const onP231UpdateDataHader = async (dataReq) => {
        let deliverNo = searchData.deliverNo;
        let req = {
            userId: searchData.userId,
            contractNo: searchData.contractNo,
            routeNo: searchData.routeNo,
            deliverNo: deliverNo,
            contractorName: NullString(dataReq.contractorName),
            letterNo: dataReq.letterNo,
            letterDate: formatDateAPI(dataReq.letterDate),
            deliverBeginDate: formatDateAPI(dataReq.deliverBeginDate),
            deliverEndDate: formatDateAPI(dataReq.deliverEndDate),
            dayDelay: NullInt(dataReq.dayDelay),
            fineAmount: NullInt(dataReq.fineAmount),
            meetingDate: formatDateAPI(dataReq.meetingDate),
            finalFlag: NullSelect(dataReq.finalFlag),
            remark: NullString(dataReq.remark),
        };

        await P231UpdateData(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    if (res.data[0].statusCode === "C") {
                        // deliverNo
                        setTextShow(res.data[0].statusText !== "" ? res.data[0].statusText : `บันทึกสมบูรณ์`);
                        deliverNo = res.data[0].deliverNo ? res.data[0].deliverNo : deliverNo;
                    } else if (res.data[0].statusCode === "E") {
                        setTextShow(res.data[0].statusText !== "" ? res.data[0].statusText : `มีข้อผิดพลาด`);
                    }

                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );

        return deliverNo;
    };

    const onP231UpdateDetailData = async (dataReq) => {
        await P231UpdateDetailData(dataReq).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    if (res.data[0].statusCode === "C") {
                        setTextShow(res.data[0].statusText !== "" ? res.data[0].statusText : `บันทึกสมบูรณ์`);
                    } else if (res.data[0].statusCode === "E") {
                        setTextShow(res.data[0].statusText !== "" ? res.data[0].statusText : `มีข้อผิดพลาด`);
                    }

                    setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const onExport = (act) => {
        // console.log(dataRPT);
        switch (act) {
            case "PDF":
                pdfRPT232(dataRPT, setLoading, setDialogPDF);
                break;
            case "WORD":
                wordRPT232(dataRPT, setLoading);
                break;
            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0" >P1 รายละเอียด</h2>
                        <hr /> */}
                        <P231Search data={searchData} dataHead={dataHead} setDataHead={setDataHead} submitted={submitted} />
                        <div className="card">
                            <div className="p-col-12">
                                <P231List dataTable={dataTable} dataCol={dataTableCol} keyListB={keyList} searchData={searchData} setDialogReport={setDialogReport} submitForm={submitForm} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} />

            <DialogOpenReport header="P1 ส่งมอบงานก่อสร้าง" dialog={dialogPDF} setDialog={setDialogPDF} />

            <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
        </>
    );
}
